export const TWITCH_VIDEO_PLAYER_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TwitchVideoPlayerWidgetElement';
